import SessionDesk from "@/pages/Dashboard";

// /primary is the Session desk scrolled to the ticket (ENTER) or the blocking rule (NO TRADE / WAIT).
// The audit helpers moved to components/desk/DeskAudit; re-exported here for older imports.
export { AuditRow, blockingProps, decisionReason, pathOf, ruleEvidence, ruleFamilies } from "@/components/desk/DeskAudit";

export default function Primary() {
  return <SessionDesk focus="ticket" />;
}
